import React, { useContext } from "react";
import { ReleaseHblInfo } from "../../../../fms.data/models/ReleaseHblInfo";
import TextBox from "../../../../ui/TextBox";
import InlineInputControlRow from "../../../../ui/layout/InlineInputControlRow";
import Fieldset from "../../../common/Fieldset";
import LeftRightSplit from "../../../../ui/LeftRightSplit";
import Float from "../../../../ui/Float";
import Date from '../../../../ui/Date';
import CheckBox from "../../../../ui/CheckBox";
import SmartTable from "../../../../uiControls/SmartTable";
import MultilineTextBox from "../../../../ui/MultilineTextBox";
import Label from "../../../../ui/Label";
import { ApplicableTableSettings } from "../../../../tableSettings";
import { DateRenderer, FloatRenderer, TextAlignLeftRenderer, TextRenderer } from "../../../../uiControls/SmartTableRenderers";
import { releaseBlContainerTable, releaseBlPaybleTable, releaseBlReceivableTable } from "../../tableSettings";
import { now } from "../../../../dateUtils";
import ApplicationContext from "../../../../ApplicationContext";


function HblRelease({
  blInfo,
  setBlInfo,
  rlsYN,
  isView,
  updateFlag, setUpdateFlag,
  relFlag, setRelFlag,
}: {
  blInfo: ReleaseHblInfo,
  setBlInfo: (x: Partial<ReleaseHblInfo>) => void,
  rlsYN: string,
  isView: boolean,
  updateFlag: boolean,
  setUpdateFlag: (x: Partial<boolean>) => void,
  relFlag: boolean,
  setRelFlag: (x: Partial<boolean>) => void,
}) {



  //<bl info - container
  function TotalNoOfContainersLabelRenderer() {
    return <div className="ifms-input-ctr-row2-label"
      style={{ textAlign: 'right', marginRight: '5px', marginTop: '5px' }}>
      Container Count: {blInfo.containers?.length ?? 0}
    </div>;
  }

  const containerTableOptions: ApplicableTableSettings = {
    tableName: 'rlsblContainer',
    ...releaseBlContainerTable,
    data: (blInfo?.containers ?? []).map((x, i) => ({
      ...x,
      no: i + 1
    })),
    rowRenderers: [
      { accessor: 'no', Cell: TextRenderer },
      { accessor: 'containerNo', Cell: TextAlignLeftRenderer },
    ],
    footerRow: [
      {
        colspan: 2,
        renderer: TotalNoOfContainersLabelRenderer
      },
    ]
  };
  //bl info - container>

  const paybleTableOptions: ApplicableTableSettings = {
    tableName: 'rlsblPayble',
    ...releaseBlPaybleTable,
    data: blInfo?.billItems ?? [],
    rowRenderers: [
      { accessor: 'postDate', Cell: DateRenderer },
      { accessor: 'vendorName', Cell: TextAlignLeftRenderer },
      { accessor: 'descript', Cell: TextAlignLeftRenderer },
      { accessor: 'invoiceNo', Cell: TextAlignLeftRenderer },
      { accessor: 'dueDate', Cell: DateRenderer },
      { accessor: 'billAmt', Cell: (props: any) => <FloatRenderer decimals={2} {...props} /> },
      { accessor: 'paidAmt', Cell: (props: any) => <FloatRenderer decimals={2} {...props} /> },
      { accessor: 'status', Cell: TextAlignLeftRenderer },
    ],
  };




  //<receivableTableOptions
  function OverDueRenderer({ cell }: any) {
    return (
      <div className="ifms-table-align-right" style={{ color: 'red', fontWeight: 'bold' }}>{cell.value}</div>
    );
  }


  function BalanceRenderer({ cell, row }: any) {
    return (
      <div style={{ color: 'blue' }}>
        <FloatRenderer cell={cell} decimals={2} row={row} />
      </div>
    );
  }

  const receivableTableOptions: ApplicableTableSettings = {
    tableName: 'rlsblReceivable',
    ...releaseBlReceivableTable,
    data: blInfo?.invoItems ?? [],
    rowRenderers: [
      { accessor: 'invoiceDate', Cell: DateRenderer },
      { accessor: 'invoiceNo', Cell: TextAlignLeftRenderer },
      { accessor: 'hblNo', Cell: TextAlignLeftRenderer },
      { accessor: 'overDue', Cell: OverDueRenderer },
      { accessor: 'invoiceAmt', Cell: (props: any) => <FloatRenderer decimals={2} {...props} /> },
      { accessor: 'paidAmt', Cell: (props: any) => <FloatRenderer decimals={2} {...props} /> },
      { accessor: 'balance', Cell: BalanceRenderer },
      { accessor: 'paidAmt', Cell: (props: any) => <FloatRenderer decimals={2} {...props} /> },
    ],
  };
  //receivableTableOptions>


  //change action

  function subEnableRelease() {
    const mainChange: Partial<ReleaseHblInfo> = {};

    mainChange.rlsBtnEnable = true;
    
    if (relFlag) {
      mainChange.rlsBtnText = 'Release';
    } else if (updateFlag) {
      mainChange.rlsBtnText = 'Update';
    } 
    // else {
    //   mainChange.rlsBtnText = '';
    // }

    setBlInfo(mainChange);
  }


  const appContext = useContext(ApplicationContext);
  const userid = appContext.user ? appContext.user.id ?? '' : '';
  const disabledRlsYn = rlsYN === 'xY';

  return (
    <div>

      <Fieldset label="B/L Information (View Only)">
        <div style={{ display: 'flex', justifyContent: 'space-between', paddingTop: 5, paddingRight: 10, paddingLeft: 10 }}>
          <div style={{ width: '280px' }}>

            <InlineInputControlRow label="Ref. #" mode="w90" smallMargin>
              <LeftRightSplit
                leftSize='130px'
                rightSize='calc(100% - 130px)'
                left={
                  <TextBox value={blInfo.refNo} disabled />
                }
                right={
                  <div style={{ marginLeft: 3 }}>
                    <TextBox value={blInfo.branch} disabled />
                  </div>
                }
              />
            </InlineInputControlRow>

            <InlineInputControlRow label="MBL #" mode="w90" smallMargin>
              <TextBox value={blInfo.mblNo} disabled />
            </InlineInputControlRow>

            <InlineInputControlRow label="B/L Acct. Carrier" mode="w90" smallMargin>
              <TextBox value={blInfo.carrier} disabled />
            </InlineInputControlRow>

            <InlineInputControlRow label="HBL #" mode="w90" smallMargin>
              <TextBox value={blInfo.hblNo} disabled />
            </InlineInputControlRow>

            <InlineInputControlRow label="Customer" mode="w90" smallMargin>
              <TextBox value={blInfo.custName} disabled />
            </InlineInputControlRow>

          </div>
          <div style={{ width: '280px' }}>

            <InlineInputControlRow label="Sub B/L #" mode="w90" smallMargin>
              <TextBox value={blInfo.subBl} disabled />
            </InlineInputControlRow>

            <LeftRightSplit
              leftSize='170px'
              rightSize='calc(100% - 170px)'
              left={
                <InlineInputControlRow label="Packages" mode="w90" smallMargin>
                  <Float value={blInfo.pkgs} disabled />
                </InlineInputControlRow>
              }
              right={
                <div style={{ marginLeft: 9, display: 'flex' }}>
                  ETA
                  <div style={{ marginLeft: 5, width: 75 }}>
                    <Date value={blInfo.podEta} disabled />
                  </div>
                </div>
              }
            />


            <LeftRightSplit
              leftSize='170px'
              rightSize='calc(100% - 170px)'
              left={
                <InlineInputControlRow label="KGS" mode="w90" smallMargin>
                  <Float value={blInfo.kgs} disabled />
                </InlineInputControlRow>
              }
              right={
                <div style={{ marginLeft: 9, display: 'flex' }}>
                  LBS
                  <div style={{ marginLeft: 5, width: 75 }}>
                    <Float value={blInfo.lbs} disabled />
                  </div>
                </div>
              }
            />

            <LeftRightSplit
              leftSize='170px'
              rightSize='calc(100% - 170px)'
              left={
                <InlineInputControlRow label="CBM" mode="w90" smallMargin>
                  <Float value={blInfo.cbm} disabled />
                </InlineInputControlRow>
              }
              right={
                <div style={{ marginLeft: 9, display: 'flex' }}>
                  CFT
                  <div style={{ marginLeft: 5, width: 75 }}>
                    <Float value={blInfo.cft} disabled />
                  </div>
                </div>
              }
            />

            <div style={{ marginLeft: '130px' }}>
              <CheckBox value={blInfo.expRls} disabled label="Express Release of MB/L" />
            </div>
          </div>

          <div style={{ width: '200px' }}>
            <SmartTable {...containerTableOptions} />
          </div>

        </div>
        <div style={{ width: '810px', display: 'flex' }}>
          <div style={{ marginLeft: 12, width: '100px' }}>
            <Label label="Public Memo" />
          </div>
          <MultilineTextBox style={{ height: '30px' }} disabled value={blInfo.pMemo} />
        </div>

      </Fieldset>


      <Fieldset label="Accounts Payable (View Only)">
        <div style={{ width: '800px', marginLeft: 10, padding: 0 }}>
          <SmartTable {...paybleTableOptions} />
        </div>
      </Fieldset>

      <Fieldset label="Accounts Receivable (View Only)">

        <div style={{ width: '800px', marginLeft: 10, padding: 0 }}>
          <SmartTable {...receivableTableOptions} />
        </div>


      </Fieldset>



      <Fieldset label="Release">

        <div style={{ display: 'flex', justifyContent: 'space-between', paddingTop: 5, paddingRight: 10, paddingLeft: 10 }}>

          <div style={{ width: '160px' }}>
            <div>
              CFS EDI Release
              <TextBox value={blInfo.cfsLoc} disabled />
            </div>

            <div>
              CFS EDI Release Date
              <div style={{ width: '75px' }}>
                <Date value={blInfo.cfsDate} disabled />
              </div>
            </div>
          </div>

          <div style={{ width: '150px' }}>
            <div style={{ marginBottom: 8 }}>
              <CheckBox value={blInfo.expRls} disabled={disabledRlsYn} label="Express Release"
                onChange={check => {
                  setBlInfo({expRls: check});
                  setUpdateFlag(true);
                  subEnableRelease();
                }}
              />
            </div>

            <div style={{ marginBottom: 8 }}>
              <CheckBox value={blInfo.printRelOrder} disabled={disabledRlsYn} label="Print Release Order on Release" 
               onChange={check => setBlInfo({printRelOrder: check}) }
              />
            </div>

            <div>
              <CheckBox value={blInfo.cfsRelOrder} disabled={disabledRlsYn ? disabledRlsYn : !blInfo.cfsYn} label="EDI CFS Release on Release" 
              onChange={check => setBlInfo({cfsRelOrder: check}) }
              />
            </div>
          </div>

          <div style={{ width: '170px' }}>
            <div style={{ marginBottom: 8 }}>
              <CheckBox value={blInfo.oblCol > 0} label="Original B/L Recveived"
                onChange={check => {
                  setBlInfo({ oblCol: check ? 1 : 0 });

                  if (blInfo.oblCol === 0) {
                    setBlInfo({ oblDate: null });
                  } else if (blInfo.oblDate === null) {
                    setBlInfo({ oblDate: now() });
                  }
                  setUpdateFlag(true);
                  subEnableRelease();
                }}

              />
            </div>

            <div style={{ display: 'flex' }}>
              O B/L Rec'd Date
              <div style={{ width: '75px', marginLeft: '5px' }}>
                <Date value={blInfo.oblDate}
                  onChange={(date) => {
                    setUpdateFlag(true);
                    subEnableRelease();
                  }}

                />
              </div>
            </div>


            {
            /**
             * 240607.dwshin. 본래 FmsComboType.Obl combo(Component Name:cbo0)가 있어야 할 위치이나, 
             * 3.3에서 visible 설정을 해주는 곳이 없어 작성하지 않음.
             */}
          </div>

          <div style={{ width: '160px' }}>
            <div>
              <CheckBox value={blInfo.rlsd} disabled={disabledRlsYn} label="Rls"
                onChange={check => {
                  setBlInfo({ rlsd : check, releaseOrder: check });

                  if (blInfo.rlsd) {
                    setBlInfo({
                      rlsDate: now(),
                      rlsBy: userid
                    });
                    setRelFlag(true);
                  } else {
                    setBlInfo({
                      rlsDate: null,
                      rlsBy: ''
                    });
                    setRelFlag(false);
                    setUpdateFlag(true);
                  }

                  subEnableRelease();
                }}
              />

              {
            /**
             * 240607.dwshin. 본래 Rls Text (Component Name:txt4)가 있어야 할 위치이나, 
             * 3.3에서 visible 설정을 해주는 곳이 없어 작성하지 않음.
             */}
            </div>

            <div style={{ display: 'flex', marginTop: '8px', marginBottom: '3px' }}>
              Rls'd Date
              <div style={{ width: '75px', marginLeft: '5px' }}>
                <Date value={blInfo.rlsDate} disabled={disabledRlsYn} />
              </div>
            </div>
            <div style={{ display: 'flex', marginLeft: '37px' }}>
              By
              <div style={{ width: '75px', marginLeft: '6px' }}>
                <TextBox value={blInfo.rlsBy} disabled={disabledRlsYn} />
              </div>
            </div>
          </div>
        </div>

      </Fieldset>
    </div>
  );
}

export default React.memo(HblRelease);
